import { history } from "../_helpers";

export const workspaceServices = {
  getWorkspaceDetails,
  getAllActiveWorkspace,
  addWorkspace,
  editWorkspace,
  deleteWorkspace,
  getWorkspaceProps,
  applyFilters,
  searchWorkspaces
};

function getWorkspaceDetails( offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspaces?offset=${offset}&limit=${limit}`,
    requestOptions
  ).then(handleResponse);
}

function addWorkspace(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
    },
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspaces`,
    requestOptions
  ).then(handleResponse);
}

function getAllActiveWorkspace() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspaces/active`,
    requestOptions
  ).then(handleResponse);
}

function editWorkspace(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
    },
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspace`,
    requestOptions
  ).then(handleResponse);
}

function deleteWorkspace(workspaceId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspace/${workspaceId}`,
    requestOptions
  ).then(handleResponse);
}

function getWorkspaceProps() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspaces/props`,
    requestOptions
  ).then(handleResponse);
}

function applyFilters(formData, offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspaces/filter/${limit}/${offset}`,
    requestOptions
  ).then(handleResponse);
}

function searchWorkspaces(search, offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/workspaces/search?search=${search}&offset=${offset}&limit=${limit}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
